module.exports = __webpack_public_path__ + "static/images/drop-off-highlighted.1ocuFxX.svg";